import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';

import { Button, Col, Modal, Row, Tab, Tabs } from "react-bootstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';

import EctLogoSimples from './../../assets/img/favi-ect.png';
import { AlertaExpedicaoContext } from "./contextsAlerta/AlertaExpedicao";
import ListaExpedicaoPendente from "./ListaExpedicaoPendente";
import ListaUnitizadorUnidadeData from "./ListaUnitizadorUnidadeData";
import ListaUnitizadorUnidadeDataObjetos from "./ListaUnitizadorUnidadeDataObjetos";
import RelatorioAlertaExcluido from "./RelatorioAlertaExcluido";
import ModalAguarde from "../../components/Modal";
import { CEPZERO } from "./utils/Constants";

const AlertaExpedicao = () => {

    const navigate = useNavigate();
    const [show, setShow] = useState<boolean>(false);
    const [mensagem, setMensagem] = useState<string>('');
    const [mapLinkVisited, setMapLinkVisited] =  useState<Map<string, string>>(new Map([]));

    const {
        key, setKey,
        keyTabTipoCarga, setKeyTabTipoCarga,
        setDataSelecionada,
        setDimensoes,
        showSpinner, setShowSpinner,
        setIPreAlertaUnitizador,
        setListaUnitizadorUnidadeData,
        setCodSroUnidadeOrigem
    } = useContext(AlertaExpedicaoContext)

    useEffect(() => {
        setShowSpinner(()=>true)
        if (key === 'resumo') {
            setListaUnitizadorUnidadeData([]);
            setIPreAlertaUnitizador(null);
            setDataSelecionada(()=>'1900-01-01')
        } else {
            setIPreAlertaUnitizador(null);
        }

        const el = document.getElementById('container-principal');
        const d = {
            width: el ? el.offsetWidth : 0,
            height: el ? el.offsetHeight : 0
        };
        setDimensoes(()=>d)
        return () => {
            //unmount
            setListaUnitizadorUnidadeData([]);
            setIPreAlertaUnitizador(null);
            setMensagem(()=>'');
            setShow(()=>false);
            setShowSpinner(()=>false);
            setMapLinkVisited(() => new Map([]));
        }
    //eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    useEffect(() => {
        setCodSroUnidadeOrigem(()=>CEPZERO)
        //eslint-disable-next-line react-hooks/exhaustive-deps
    },[key]);

    const isLinkClicado = (key: any) : boolean => {
        return mapLinkVisited.has(key);
    };

    const linkClicado = (key: any) => {
        if(!mapLinkVisited.has(key)) mapLinkVisited.set(key,'');
    };

    const handleSelect = (keySelected: string) => {

        setShowSpinner(() => false)
        setDataSelecionada(()=>'1900-01-01');
        if(keyTabTipoCarga !== 'urg') setKeyTabTipoCarga(() => 'urg');

        setKey(() => keySelected);
    }

    const handleClose = () => {
        setMensagem(()=>'')
        setShow(false)
    };

    return (
        <>

            <Breadcrumb>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
                <Breadcrumb.Item active>{`Alerta Expedição ${key.charAt(0).toUpperCase() + key.substring(1)}`}</Breadcrumb.Item>
            </Breadcrumb>

            <Row>

                <Col sm={12} md={12} lg={2} className="cabecalho-menus-buttons">
                    <Link hidden id="btn-bottom-voltar" className="btn btn-secondary  me-2" role="button" onClick={() => navigate(-1)} to={"#"}>Voltar</Link>
                    <Link hidden id="btn-bottom-salvar" className="btn btn-primary" role="button" onClick={() => navigate(-1)} to={"#"}>Salvar</Link>
                </Col>
            </Row>
            <Tabs id="tabs"
                defaultActiveKey="resumo"
                activeKey={key}
                onSelect={(k) => { handleSelect(k ? k : 'resumo') }}
                className="mb-2 fs-5 padding-tab-principal"
            >
                <Tab eventKey="resumo" title="Resumo">
                    <ListaExpedicaoPendente />
                </Tab>

                <Tab eventKey="unitizadores" title="Unitizadores">
                    {key === "unitizadores" ?
                        <ListaUnitizadorUnidadeData linkClicado={linkClicado} isLinkClicado={isLinkClicado}/>

                        :

                        null
                    }
                </Tab>

                <Tab eventKey="objetos" title="Objetos">

                    {key === "objetos" ?
                        <ListaUnitizadorUnidadeDataObjetos linkClicado={linkClicado} isLinkClicado={isLinkClicado}/>

                        :

                        null
                    }

                </Tab>
                <Tab eventKey="roes" title="ROE">
                    <RelatorioAlertaExcluido linkClicado={linkClicado} isLinkClicado={isLinkClicado}/>
                </Tab>
            </Tabs>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img src={EctLogoSimples}
                        alt="Logo ECT"
                        className="rounded me-2"
                        />
                        <strong className="me-auto">sroconferencia</strong>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {mensagem}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>

            <ModalAguarde show={showSpinner} setShow={setShowSpinner}/>

        </>
    )
}

export default AlertaExpedicao